import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { createPortal } from 'react-dom'
import { toast } from 'react-toastify';
import Constants from '../../Utility/Constants';
import { AddPaymentHTMLTemplate } from './AddPaymentTemplate';


export const IFrame = ({
    children,
    ...props
}) => {
    const [contentRef, setContentRef] = useState(null);
    const history = useHistory()
    const mountNode =
        contentRef?.contentWindow?.document?.body

    const loadedScreen = () => {
        try {
            const currentPath = document.getElementById("payment_iframe_id").contentWindow.location.href;
            const { isCart } = history.location.state;
            if (currentPath.includes('/worldnet/success.html')) {
                toast.success(`${Constants.PAYMENT.saveCard}`, {
                    position: toast.POSITION.TOP_RIGHT,
                    toastId: "card_account_success",
                });
                if (isCart) {
                    history.replace('checkout/payment');
                } else {
                    history.replace('myaccounts/payment');
                }

            } else {
                toast.error('This card information is already exist. Please try different card', {
                    position: toast.POSITION.TOP_RIGHT,
                    toastId: "card_account_failure",
                });
                if (isCart) {
                    history.replace('checkout/payment');
                } else {
                    history.replace('myaccounts/payment');
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            <iframe
                title="payment_iframe_title"
                id="payment_iframe_id"
                ref={setContentRef}
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="no"
                onLoad={loadedScreen}
                {...props}
            >
                {mountNode && createPortal(children, mountNode)}
            </iframe>
        </div>
    )
}

export class AddPaymentScreen extends React.Component {

    render() {
        const { htmlTemplate } = this.props.location.state;
        return htmlTemplate ? <IFrame>
            <AddPaymentHTMLTemplate data={htmlTemplate} />
        </IFrame> : null
    }
}

export default withRouter(AddPaymentScreen)